export default __webpack_public_path__ + "static/media/video.bd6fc385.svg";